// extracted by mini-css-extract-plugin
module.exports = {"substormsWrapper":"styles_substormsWrapper__1r51e","substorm":"styles_substorm__3Wq_l","substormTitle":"styles_substormTitle__12V3P"};